
export default{
    setName(state,msg){
        state.name=msg
    },
    setRoleId(state, msg) {
        state.roleId = msg;
    } ,
    setRoleName(state, msg) {
        state.roleName = msg;
    } ,
    setRoleType(state, msg) {
        state.roleType = msg;
    } ,
    setUserName(state, msg) {
        state.userName = msg;
    } ,
    setCrumbsArr(state, msg) {
        state.crumbsArr = msg;
    },
    setMenu(state, msg) {
        state.menu = msg;
    },
    setJumpMenu(state, msg) {
        state.jumpMenu = msg;
    },
    setLogUrl(state, msg) {
        state.logUrl = msg;
    },
    setMenuWidth(state, msg) {
        state.menuWidth = msg;
    },
    setButtons(state, msg) {
        state.buttons = msg;
    },
    setTokens(state, msg) {
        state.tokens = msg;
    },
    setWeixinInfo(state, msg){
        state.weixinInfo = msg;
    },
    setRealNameResult(state, msg){
        state.realNameResult = msg;
    },
    // Tabs视图和缓存
    setVisitedViews(state, msg){
        state.visitedViews = msg;
    },
    setCachedViews(state, msg){
        state.cachedViews = msg;
    }

}


// WEBPACK FOOTER //
// ./src/views/store/mutations.js